import React from 'react';
import { useTranslation } from 'react-i18next';
import { AddModelButton, DataTable, DeleteModelButton, GetContentButton, Panel, RenderIf, Toolbar } from '@lib/ui-components';
import VisibilityIcon from '@mui/icons-material/Visibility';
import { CompanyViewModel } from '@lib/api-interface';
import * as Yup from 'yup';

export interface ContractorOtherDecisionsProps {
  company: CompanyViewModel;
  addNewDocumentButtonHidden?: boolean;
}

export function ContractorOtherDecisions(props: ContractorOtherDecisionsProps) {
  const [tableReloadKey, setTableReloadKey] = React.useState(1);
  const { t } = useTranslation();

  return (
    <Panel borderType='none'>
      <RenderIf false={props.addNewDocumentButtonHidden}>
        <Toolbar
          right={[
            <AddModelButton key='add-model-button-22'
              multipart={true}
              buttonLabel={t('uploadFile')}
              dialogTitle={t('uploadFile')}
              url={'/api/resource/companyFileViews'}
              fields={[
                {
                  label: t('branch'),
                  type: 'table-select',
                  field: 'companyBranchId',
                  tableSelectParams: {
                    fetchUrl: '/api/resource/companyBranchViews',
                    dialogTitle: t('branch'),
                    displayFormat: '{name}',
                    selectedValueField: 'branchId',
                    columns: [{ key: 'name', label: t('Model.CompanyBranch.name'), type: 'text' }],
                    fetchFilters: { companyId: props.company.companyId },
                  },
                },
                { label: t('dragAndDropAFile'), type: 'file', field: 'content' },
                { label: t('comment'), type: 'text', field: 'comment' },
              ]}
              validationSchema={{
                companyBranchId: Yup.string().required(t('fieldRequired')),
              }}
              hiddenValues={{ type: 'CONTRACTOR_OTHER', companyId: props.company.companyId }}
              onSaved={async () => setTableReloadKey(tableReloadKey + 1)}
            />,
          ]}
        />
      </RenderIf>
      <DataTable
        refreshKey={tableReloadKey}
        fetchUrl={'/api/resource/companyFileViews'}
        fetchFilters={{ companyId: props.company.companyId, type: 'CONTRACTOR_OTHER' }}
        columns={[
          {
            key: 'fileName',
            label: t('otherDecisions'),
            type: 'text',
          },
          {
            key: 'companyBranch.name',
            label: t('Model.CompanyBranch.name'),
            type: 'text',
          },
          {
            key: 'companyBranch.registrationAddress.town',
            label: t('locality'),
            type: 'text',
          },
          {
            key: 'companyBranch.registrationAddress.street',
            label: t('street'),
            type: 'text',
          },
          {
            key: 'creationDate',
            label: t('uploadDate'),
            type: 'date',
          },
          {
            key: 'createdBy',
            label: t('addedBy'),
            type: 'text',
          },
          {
            key: 'comment',
            label: t('comment'),
            type: 'text',
          },
        ]}
        rowOptions={[
          {
            renderer: (row) => <GetContentButton label={t('viewFile')} icon={<VisibilityIcon />} resourcePath={`api/resource/companyFileViews/${row.id}/content`} />,
          },
          {
            renderer: (row) => <DeleteModelButton url={'/api/resource/companyFileViews'} id={row.id} onDeleted={async () => setTableReloadKey(tableReloadKey + 1)} />,
          },
        ]}
      />
    </Panel>
  );
}
